export const OwnerEnv = {
  title: process.env.REACT_APP_BASE_TITLE,
  domain: process.env.REACT_APP_BASE_DOMAIN,
  apiUrl: process.env.REACT_APP_BACKEND_URL,
  assetsUrl: process.env.REACT_APP_ASSETS_URL,
  subdomainReditectHost: process.env.REACT_APP_SUBDOMAIN_REDIRECT_HOST,
  company: {
    name: process.env.REACT_APP_COMPANY_NAME,
    phone: process.env.REACT_APP_COMPANY_PHONE,
    mail: process.env.REACT_APP_COMPANY_MAIL,
    address: process.env.REACT_APP_COMPANY_ADDRESS,
  },
  bank: {
    name: process.env.REACT_APP_BANK_NAME || '----- ----- A.Ş.',
    iban:
      process.env.REACT_APP_BANK_IBAN || 'TR-- ----- ----- ----- ----- -----',
    accountHolder: process.env.REACT_APP_BANK_ACCOUNT_HOLDER || '-----',
  },
};
